/**
 * Manages keyboard events related to the tablist in order to adhere to a11y
 * tabs as specified by
 * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/tab_role
 */
function handleTablistKeydownEvent(evt) {
  const tablist = evt.currentTarget;
  const tablistButtons = Array.from(tablist.children);
  const currentButton = evt.target;
  if (!currentButton) {
    return;
  }
  const currentIndex = Array.from(tablist.children).indexOf(currentButton);
  switch (evt.key) {
    case "ArrowRight":
      {
        const wrappedNextIndex = currentIndex === tablistButtons.length - 1 ? 0 : currentIndex + 1;
        tablistButtons[wrappedNextIndex]?.focus();
        break;
      }
    case "ArrowLeft":
      {
        const wrappedNextIndex = currentIndex === 0 ? tablistButtons.length - 1 : currentIndex - 1;
        tablistButtons[wrappedNextIndex]?.focus();
        break;
      }
  }
}

export { handleTablistKeydownEvent };
//# sourceMappingURL=util.key-down.js.map
